import { render } from "./FormStep5.vue?vue&type=template&id=b0b39120"
import script from "./FormStep5.vue?vue&type=script&lang=js"
export * from "./FormStep5.vue?vue&type=script&lang=js"

import "./FormStep5.vue?vue&type=style&index=0&id=b0b39120&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__